import { Box, Typography, Paper } from '@mui/material';

export default function Archive() {
  return (
    <Box sx={{ p: 3 }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: 4, 
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          minHeight: '80vh'
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          Archive
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This section is under development. It will contain archived influencer profiles and past campaigns.
        </Typography>
      </Paper>
    </Box>
  );
} 